module.exports = __webpack_public_path__ + "static/media/logo-you@2x.5ba58036.png";